define((require) => {
    "use strict";

    let Marionette            = require("marionette"),
        $                     = require("jquery"),
        _                     = require("underscore"),
        TweenMax              = require("TweenMax"),
        ProjectCollectionView = require("ui/projects/ProjectCollectionView"),
        LoggedIn              = require("shared/security/LoggedIn"),
        LoggedInUserState     = require("shared/ui/user/LoggedInUserState");

    const PROJECT_PANEL_EXPANDED = "projects-panel-expanded";

    let $html = $("html"),
        $mainOverlay = $(".main-overlay"),
        $projectsPanel = $(".projects-panel");

    /**
     * @class  ProjectSelector
     */
    const ProjectSelector = Marionette.Controller.extend({

        /**
         * @type {ProjectCollectionView}
         */
        _view: null,

        initialize() {
            // Debounced to allow multiple calls during the same callstack. E.g. by default we close
            // the selector when the location/route changes, in some cases we might wanna keep the selector open.
            this.toggleProjectSelector = _.debounce(this.toggleProjectSelector, 150).bind(this);
        },

        /**
         * Initializes the ProjectSelector.
         *
         * @param  {Region} region The region to show the project selector.
         */
        start(region) {
            this.listenTo(LoggedInUserState, "change:ready", function(model, ready) {
                if (ready) {
                    const projects = LoggedInUserState.get("projects");

                    this._view = new ProjectCollectionView({
                        collection: projects
                    });

                    region.show(this._view);
                }
            });

            this.listenTo(LoggedInUserState, "change:location", function() {
                this.toggleProjectSelector(false);
            });

            this.listenTo(LoggedIn, "change:login", function(principal) {
                if (principal) { // signed in principal
                    if (principal.get("updated")) { // re-signin to get normal role (no longer spectator)
                        this._view.render();
                    }
                } else { // signed out
                    region.close();
                }
            });

            $mainOverlay.on("click", () => this.toggleProjectSelector(false));

            $projectsPanel.on("transitionend", () => {
                if (!$html.hasClass(PROJECT_PANEL_EXPANDED)) {
                    $projectsPanel.toggleClass("show", false);
                }
            });
        },

        /**
         * Toggles the project selector.
         *
         * @param {Boolean} toggle Optional, whether to show or hide the selector.
         */
        toggleProjectSelector(toggle) {
            $html.toggleClass(PROJECT_PANEL_EXPANDED, toggle);

            if (toggle || $html.hasClass(PROJECT_PANEL_EXPANDED)) {
                $projectsPanel.toggleClass("show", true);
            }

            // Let TweenMax handle fade in/out of the main overlay - hiding it (display:none) when fully transparent
            if ($html.hasClass(PROJECT_PANEL_EXPANDED)) {
                $mainOverlay.show();
                TweenMax.to($mainOverlay, 0.5, {
                    opacity: 1
                });
            } else {
                TweenMax.to($mainOverlay, 0.5, {
                    opacity: 0,
                    onComplete: $mainOverlay.hide.bind($mainOverlay)
                });
            }
        }

    });

    // Singleton
    return new ProjectSelector();
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/ProjectSelector.js